export const AMAZON_STORENAMES = [
  'AMZ*',
  'AMZ*com',
  'AMZ* WEB',
  'AMZ*WEB',
  'AMZ*e',
  'AMZ*EC',
  'AMZ*ID',
  'AMZ*-',
  'AMZ*–',
];

export const AMZ_SUB_MERCHANTS_IDS = {
  amazonPay: 'sme_YqcDC60AAK0AuN2I',
  amazonPrime: 'sme_Xes53cu5PB0BPOf0',
  amazonKindle: 'sme_Xk57ZgEAAAEAv3bu',
  amazonMusic: 'sme_Xp1gGdVO6ZkBTgUa',
  amazonPharmacy: 'sme_YqcDCa0AAK0AuN2H',
  amazonPrimeVideo: 'sme_YseYmXkAAHkAPhN8',
  amazonRetail: 'sme_V48KvPRYezUAGnZT',
  amazonMarketplace: 'sme_rtD3ejNtqvh18sD2',
};
